
import { defineComponent, ref, onUpdated, nextTick, PropType } from 'vue'
import ListHeader from '@/components/ListHeader.vue'

export default defineComponent({
  name: 'InputHeader',
  components: { ListHeader },
  props: {
    modelValue: {
      type: [String, Number]
    },
    loading: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: [String, Number]
    },
    type: {
      type: String as PropType<'text' | 'number' | 'currency' | 'phone'>
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    step: {
      type: Number
    }
  },
  emits: ['update:modelValue'],
  setup (props, context) {
    const input = ref()
    const editing = ref<boolean>(false)

    function save (value) {
      editing.value = false
      context.emit('update:modelValue', value)
    }

    function toggleEdit () {
      if (props.readonly) return
      editing.value = props.loading ? false : true
      const element: HTMLInputElement = input.value?.$refs[`ozn-input-${ input.value?.id }`]
      void nextTick(() => {
        if (element) element.focus()
      })

    }

    return {
      toggleEdit,
      editing,
      save,
      input
    }
  }
})
